






































































































import { Vue, Component } from 'vue-property-decorator';

import { AuditService, IAuditResult, IPartialTxAuditResult } from 'simple-apostille-v2';
import * as fileReader from 'promise-file-reader';
import AppConfig from '@/libs/AppConfig';
import {
  TransactionHttp,
  TransactionGroup,
  Order,
  TransactionSearchCriteria,
  Transaction,
  AggregateTransaction,
  PublicAccount,
  Address,
} from 'symbol-sdk';
import { LocalDateTime } from '@js-joda/core';
import ApostilleService from '@/libs/ApostilleService';
import FileDropArea from '../components/createapostille/FileDropArea.vue';
import PartialTransactionModal from '../components/history/PartialTransactionModal.vue';

interface TxStatus {
  transaction: Transaction | AggregateTransaction;
  group: TransactionGroup;
}

@Component({
  components: {
    FileDropArea,
    PartialTransactionModal,
  },
})

export default class History extends Vue {
  private file: File | null = null;

  private isDragOver = false;

  private txHash = '';

  private auditResult: IAuditResult | IPartialTxAuditResult | null = null;

  private filename = '';

  private apiEndPoint = AppConfig.apiEndpoint();

  private epochAdjustment = AppConfig.epochAdjustment();

  private showAlert = false;

  private isValid = false;

  private transactions: TxStatus[] = []

  private isOpen = false;

  private selectTransaction?: Transaction;

  private signedCosignatories: Address[] = []; // 署名済み

  private cosignatories: Address[] = []; // 連署者

  private alertType = '';

  private alertText = '';

  private onChange(event: any) {
    const { files } = event.target;
    this.file = files[0] as File;
  }

  private showAlertNotApostilleFile() {
    this.showAlert = true;
    this.alertType = 'error';
    this.alertText = 'このファイルはアポスティーユフォーマットではありません';
  }

  private showAlertFailedAudit() {
    this.showAlert = true;
    this.alertType = 'warning';
    this.alertText = '監査に失敗しました.';
  }

  private onClickRemoveFile() {
    this.file = null;
  }

  private timestamp(time: LocalDateTime) {
    return time.toString().replace('T', ' ').split('.')[0];
  }

  private async onClickAudit() {
    this.resetResult();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refs: any = this.$refs;
    if (refs.form.validate() && this.file) {
      this.getTxHash(this.file.name);
      if (this.txHash) {
        await this.audit();
      } else {
        this.showAlertNotApostilleFile();
      }
    }
  }

  private onClickRest() {
    this.file = null;
    this.resetResult();
  }

  private resetResult() {
    this.auditResult = null;
    this.showAlert = false;
    this.alertType = '';
    this.alertText = '';
  }

  private async getMultisigAccountInfo() {
    if (this.auditResult && this.auditResult.apostilleAccount) {
      this.cosignatories = await ApostilleService
        .getMultisigAccountCosigner(this.auditResult.apostilleAccount);
    }
  }

  private openModal(tx: TxStatus) {
    if (tx.group === TransactionGroup.Confirmed) {
      window.location.href = `http://explorer.testnet.symboldev.network/transactions/${tx.transaction.transactionInfo?.hash}`;
      return;
    }
    this.isOpen = true;
    if (tx.transaction instanceof AggregateTransaction) {
      const { signer, cosignatures } = tx.transaction;
      if (signer instanceof PublicAccount) this.signedCosignatories.push(signer.address);
      cosignatures.forEach((c) => this.signedCosignatories.push(c.signer.address));
    }

    this.selectTransaction = tx.transaction;
  }

  private getTxHash(filename: string) {
    const regexp = /--\sApostille\sTX\s(\w+)\s--/;
    const match = filename.match(regexp);
    if (match) {
      this.txHash = match[1] as string;
    }
  }

  private compare(a: TxStatus, b: TxStatus) { // 大きい順
    return a.transaction.deadline.adjustedValue - b.transaction.deadline.adjustedValue < 0 ? 1 : -1;
  }

  private async audit() {
    this.transactions = [];
    if (this.file && this.txHash) {
      this.filename = this.file.name;
      const fileBuffer = await fileReader.readAsArrayBuffer(this.file);
      AuditService.audit(
        fileBuffer,
        this.txHash,
        AppConfig.apiEndpoint(),
      ).then((r) => {
        this.auditResult = r;
        const txHttp = new TransactionHttp(this.apiEndPoint);
        const searchCriteria: TransactionSearchCriteria = {
          group: TransactionGroup.Partial,
          address: r.apostilleAccount,
          pageNumber: 1,
          pageSize: 100,
          order: Order.Desc,
        };
        txHttp.search(searchCriteria).subscribe(
          (txInfo) => {
            txInfo.data.forEach((tx) => {
              this.transactions.push({
                transaction: tx,
                group: TransactionGroup.Partial,
              });
            });
          },
        );
        const searchCriteria2: TransactionSearchCriteria = {
          group: TransactionGroup.Confirmed,
          address: r.apostilleAccount,
          pageNumber: 1,
          pageSize: 100,
          order: Order.Desc,
        };
        txHttp.search(searchCriteria2).subscribe(
          (txInfo) => {
            txInfo.data.forEach((tx) => {
              this.transactions.push({
                transaction: tx,
                group: TransactionGroup.Confirmed,
              });
            });
          },
        );
        this.transactions.sort(this.compare);
        this.getMultisigAccountInfo();
      }).catch((err) => {
        console.error(err);
        this.showAlertFailedAudit();
      });
    }
  }
}
